import { BRAND_LOADING, BRAND_FAILED, BRAND_SUCCESS, RESET_ERROR } from "../constants/brandConstants";


export const brandReducers = (state = { error: null }, action) => {
    switch (action.type) {

        case BRAND_LOADING:
            return {
                ...state,
                loading: action.payload
            }

        case BRAND_SUCCESS:
            return {
                ...state,
                brandData: action.payload,
                addbrandSuccess:true,
                // authenticatedUser: true
            }

        case BRAND_FAILED:
            return {
                ...state,
                error: action.payload,
            }
        case RESET_ERROR:
            return {
                ...state,
                addbrandSuccess:null,
                error: null
            }

        default:
            return state;

    }

}